<template>
  <div class="wrapper-x-40">
    <AdminStickyHeader>
      <template #title>
        {{ barrier ? $t('main.title_edit_element') + ":" : $t('main.title_add_element') + ":" }}
        {{ $t('main.barrier') }}
      </template>
      <template #actions>
        <Loading
          v-if="loadingSaveData"
          class="mb-2"
        />
        <div class="form-group flex flex-wrap items-center gap-3">

          <button
            @click="saveClose"
            type="button"
            class="btn btn-small btn-default"
          >
            {{ $t('main.button_save_close') }}
          </button>

          <button
            @click="save"
            type="button"
            class="btn btn-small btn-green"
          >
            {{ $t('main.button_save') }}
          </button>

          <button
            @click="saveCreate"
            type="button"
            class="btn btn-small btn-default"
          >
            <i
              class="fa fa-plus"
              aria-hidden="true"
            ></i>
            {{ $t('main.button_save_create') }}
          </button>

          <router-link
            class="btn btn-small btn-red"
            :to="{
              name: 'barriers',
              query: $route.query
            }"
          >{{ $t('main.button_cancel') }}</router-link>

          <button
            @click="saveCopy"
            type="button"
            class="btn btn-small btn-blue"
          >
            {{ $t('main.button_save_copy') }}
          </button>

          <BaseButtonCopyLink
            v-if="barrier"
            :elementId="barrier.barrier_id"
            groupElement="barrier"
            type="form"
          />

        </div>
      </template>
    </AdminStickyHeader>
    <div class="form ">
      <div class="flex items-start">
        <div class="w-1/3">
          <div class="form-group">
            <label
              for="name"
              class="font-bold"
            >{{ $t('main.label_name') }} *:</label>
            <div class="flex items-center">
              <input
                id="name"
                type="text"
                v-model="form.name"
              />
            </div>
            <ValidationErrors :errors="errorsFor('name')" />
          </div>

          <div class="form-group">
            <label
              for="article"
              class="font-bold"
            >{{ $t('main.label_articul') }}</label>
            <div class="flex items-center">
              <input
                id="article"
                type="text"
                v-model="form.article"
              />
            </div>
            <ValidationErrors :errors="errorsFor('article')" />
          </div>

          <div class="form-group">
            <label
              for="type_id"
              class="font-bold"
            >{{ $t('main.select_type') }} *:</label>
            <div class="flex items-center">
              <select
                id="type_id"
                v-model="form.type_id"
              >
                <option :value="0">{{ $t('main.type_not_selected') }}</option>
                <option
                  v-for="type in types"
                  :key="type.data.type_id"
                  :value="type.data.type_id"
                >
                  {{ type.data.attributes.name }}
                </option>
              </select>
            </div>
            <ValidationErrors :errors="errorsFor('type_id')" />
          </div>

          <div class="form-group">
            <label class="font-bold">{{ $t('main.label_status') }}: </label>
            <div>
              <button
                class="rounded flex items-center focus:outline-none gap-2"
                @click="form.status = form.status == 1 ? 0 : 1"
              >
                <span class="check"><i
                    v-if="form.status == 1"
                    class="fas fa-check text-red-500"
                  ></i></span>
                <span class="text-sm">{{$t('main.published')}}</span>
              </button>
            </div>
          </div>

          <div class="form-group bg-lightblue-border">
            <div class="flex items-center">
              <label
                for="image"
                class="font-bold"
              >{{ $t('main.label_image') }}:
              </label>
              <div class="help ml-2 flex">
                <button class="
                    bg-gray-400
                    flex
                    justify-center
                    items-center
                    text-white
                    w-4
                    h-4
                    rounded-full
                    focus:outline-none
                  ">
                  ?
                </button>
              </div>
            </div>

            <FileInputBlock
              :prefill="imagePreview"
              :selectedImageFileNameDefault="$t('main.image_not_selected')"
              :alreadyLoadText="$t('main.image_selected')"
              :loadedFile="this.barrier&&this.barrier.image"
              @selected-file="(file) => selectFile(file, 'Image')"
              @remove-file="removeFile('Image')"
            >
              <ValidationErrors :errors="errorsFor('image')" />
            </FileInputBlock>

          </div>

          <div class="form-group bg-lightdarkblue-border">
            <div class="flex items-center">
              <label
                for="model3d"
                class="font-bold"
              >{{$t('admin.views.barriers.form.3d_model_polotna')}}*:
              </label>
              <div class="help ml-2 flex">
                <button class="
                    bg-red-700
                    flex
                    justify-center
                    items-center
                    text-white
                    w-4
                    h-4
                    rounded-full
                    focus:outline-none
                  ">
                  ?
                </button>
              </div>
            </div>
            <FileInputBlock
              :prefill="model3dCanvasPreview"
              :selectedImageFileNameDefault="$t('main.3d_model_not_selected')"
              :alreadyLoadText="$t('main.3d_model_selected')"
              :loadedFile="this.barrier&&this.barrier.model3dCanvas"
              @selected-file="(file) => selectFile(file, 'Model3dCanvas')"
              @remove-file="removeFile('Model3dCanvas')"
            >
              <ValidationErrors :errors="errorsFor('model3dcanvas')" />
            </FileInputBlock>

          </div>
          <div class="form-group bg-lightdarkblue-border">
            <div class="flex items-center">
              <label
                for="model3d"
                class="font-bold"
              >{{$t('admin.views.barriers.form.3d_model_stolbika')}}*:
              </label>
              <div class="help ml-2 flex">
                <button class="
                    bg-red-700
                    flex
                    justify-center
                    items-center
                    text-white
                    w-4
                    h-4
                    rounded-full
                    focus:outline-none
                  ">
                  ?
                </button>
              </div>
            </div>

            <FileInputBlock
              :prefill="model3dColumnPreview"
              :selectedImageFileNameDefault="$t('main.3d_model_not_selected')"
              :alreadyLoadText="$t('main.3d_model_selected')"
              :loadedFile="this.barrier&&this.barrier.model3dColumn"
              @selected-file="(file) => selectFile(file, 'Model3dColumn')"
              @remove-file="removeFile('Model3dColumn')"
            >
              <ValidationErrors :errors="errorsFor('model3dcolumn')" />
            </FileInputBlock>

          </div>
          <div class="form-group bg-lightdarkblue-border">
            <div class="flex items-center">
              <label
                for="model3d"
                class="font-bold"
              >{{$t('admin.views.barriers.form.3d_model_kalitki')}}*:
              </label>
              <div class="help ml-2 flex">
                <button class="
                    bg-red-700
                    flex
                    justify-center
                    items-center
                    text-white
                    w-4
                    h-4
                    rounded-full
                    focus:outline-none
                  ">
                  ?
                </button>
              </div>
            </div>

            <FileInputBlock
              :prefill="model3dGatePreview"
              :selectedImageFileNameDefault="$t('main.3d_model_not_selected')"
              :alreadyLoadText="$t('main.3d_model_selected')"
              :loadedFile="this.barrier&&this.barrier.model3dGate"
              @selected-file="(file) => selectFile(file, 'Model3dGate')"
              @remove-file="removeFile('Model3dGate')"
            >
              <ValidationErrors :errors="errorsFor('model3dgate')" />
            </FileInputBlock>

          </div>
        </div>
        <div class="w-2/3 ml-30">
          <div class="form-group">
            <label class="font-bold">{{$t('main.sizes')}}:</label>
            <div class="flex items-end gap-5">
              <div>
                <label for="length_to_repeat">{{$t('admin.views.barriers.form.length_polotna_do_povtoreniya')}}</label>
                <div class="w-16">
                  <input
                    id="length_to_repeat"
                    type="text"
                    v-model="form.length_to_repeat"
                    class="text-right"
                    placeholder="000"
                  />
                </div>

                <ValidationErrors :errors="errorsFor('length_to_repeat')" />
              </div>
              <div>
                <label for="length_door">{{$t('admin.views.barriers.form.length_kalitki')}}</label>
                <div class="w-16">
                  <input
                    id="length_door"
                    type="text"
                    v-model="form.length_door"
                    class="text-right"
                    placeholder="000"
                  />
                </div>
                <ValidationErrors :errors="errorsFor('length_door')" />
              </div>
              <div>
                <label for="height_on_earth">{{$t('admin.views.barriers.form.height_on_earth')}}</label>
                <div class="w-16">
                  <input
                    id="height_on_earth"
                    type="text"
                    v-model="form.height_on_earth"
                    class="text-right"
                    placeholder="000"
                  />
                </div>
                <ValidationErrors :errors="errorsFor('height_on_earth')" />
              </div>
            </div>
          </div>

          <div class="mt-8 mb-8 flex gap-4">
            <button
              class="rounded flex items-center focus:outline-none gap-2"
              @click="form.bez_kalitki = form.bez_kalitki === 1 ? 0 : 1"
            >
              <span class="check"><i
                  v-if="form.bez_kalitki === 1"
                  class="fas fa-check text-red-500"
                ></i></span>
              <span class="text-sm">{{$t('admin.views.barriers.form.bez_kalitki')}}</span>
            </button>
            <button
              class="rounded flex items-center focus:outline-none gap-2"
              @click="form.bez_prohoda = form.bez_prohoda === 1 ? 0 : 1"
            >
              <span class="check"><i
                  v-if="form.bez_prohoda === 1"
                  class="fas fa-check text-red-500"
                ></i></span>
              <span class="text-sm">{{$t('admin.views.barriers.form.bez_prohoda')}}</span>
            </button>
          </div>

          <div class="form-group">
            <label
              for="price_pog_metr"
              class="font-bold"
            >{{$t('admin.views.barriers.form.price_pog_metr')}}</label>
            <div class="flex items-center gap-6">
              <div>
                <div class="w-28">
                  <input
                    id="price_pog_metr"
                    type="number"
                    v-model="form.price_pog_metr"
                    class="text-right w-20"
                    placeholder="0.00"
                  />
                </div>

                <ValidationErrors :errors="errorsFor('price_pog_metr')" />
              </div>
              <div class="flex gap-2 items-center cost-value">
                <label for="cost_pog_metr">{{$t('main.label_cost_price_currency')}}</label>
                <div class="w-28">
                  <input
                    id="cost_pog_metr"
                    type="number"
                    v-model="form.cost_pog_metr"
                    class="text-right"
                    placeholder="0.00"
                  />
                </div>

                <ValidationErrors :errors="errorsFor('cost_pog_metr')" />
              </div>

            </div>

          </div>
          <div class="form-group">
            <label
              for="price_add_stolbik"
              class="font-bold"
            >{{$t('admin.views.barriers.form.price_add_stolbik')}}</label>
            <div class="flex items-center gap-6">
              <div>
                <div class="w-28">
                  <input
                    id="price_add_stolbik"
                    type="number"
                    v-model="form.price_add_stolbik"
                    class="text-right"
                    placeholder="0.00"
                  />
                </div>
                <ValidationErrors :errors="errorsFor('price_add_stolbik')" />
              </div>
              <div class="flex gap-2 items-center cost-value">
                <label for="cost_add_stolbik">{{$t('main.label_cost_price_currency')}}</label>
                <div class="w-28">
                  <input
                    id="cost_add_stolbik"
                    type="number"
                    v-model="form.cost_add_stolbik"
                    class="text-right"
                    placeholder="0.00"
                  />
                </div>

                <ValidationErrors :errors="errorsFor('cost_add_stolbik')" />
              </div>

            </div>

          </div>
          <div class="form-group">
            <label
              for="price_installation"
              class="font-bold"
            >{{$t('admin.views.barriers.form.price_install')}}</label>
            <div class="flex items-center gap-6">
              <div>
                <div class="w-28">
                  <input
                    id="price_installation"
                    type="number"
                    v-model="form.price_installation"
                    class="text-right"
                    placeholder="0.00"
                  />
                </div>
                <ValidationErrors :errors="errorsFor('price_installation')" />
              </div>
              <div class="flex gap-2 items-center cost-value">
                <label for="cost_installation">{{$t('main.label_cost_price_currency')}}</label>
                <div class="w-28">
                  <input
                    id="cost_installation"
                    type="number"
                    v-model="form.cost_installation"
                    class="text-right"
                    placeholder="0.00"
                  />
                </div>

                <ValidationErrors :errors="errorsFor('cost_installation')" />
              </div>
            </div>

          </div>
          <div class="form-group">
            <label
              for="price_installation_in_base"
              class="font-bold"
            >{{$t('admin.views.barriers.form.price_install_montirovanie')}}</label>
            <div class="flex items-center gap-6">
              <div>
                <div class="w-28">
                  <input
                    id="price_installation_in_base"
                    type="number"
                    v-model="form.price_installation_in_base"
                    class="text-right"
                    placeholder="0.00"
                  />
                </div>
                <ValidationErrors :errors="errorsFor('price_installation_in_base')" />
              </div>
              <div class="flex gap-2 items-center cost-value">
                <label for="cost_installation_in_base">{{$t('main.label_cost_price_currency')}}</label>
                <div class="w-28">
                  <input
                    id="cost_installation_in_base"
                    type="number"
                    v-model="form.cost_installation_in_base"
                    class="text-right"
                    placeholder="0.00"
                  />
                </div>

                <ValidationErrors :errors="errorsFor('cost_installation_in_base')" />
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AdminStickyHeader from "../../../components/Admin/StickyHeader.vue";
import validationErrors from "../../../mixins/validationErrors";

const defaultImagePreview = "/images/design/zaglushka-prevyu.svg";
const defaultModel3dPreview = "/images/design/zaglushka-3d.svg";
const model3dUploaded = "/images/design/3d-model-uploaded.svg";

export default {
  name: "Form",
  components: { AdminStickyHeader },
  mixins: [validationErrors],
  props: {
    barrier: {
      type: Object,
    },
  },
  data() {
    return {
      imagePreview: this.barrier
        ? this.barrier.image || defaultImagePreview
        : defaultImagePreview,
      model3dCanvasPreview: this.barrier
        ? (this.barrier.model3dCanvas && model3dUploaded) ||
          defaultModel3dPreview
        : defaultModel3dPreview,
      model3dColumnPreview: this.barrier
        ? (this.barrier.model3dColumn && model3dUploaded) ||
          defaultModel3dPreview
        : defaultModel3dPreview,
      model3dGatePreview: this.barrier
        ? (this.barrier.model3dGate && model3dUploaded) || defaultModel3dPreview
        : defaultModel3dPreview,
      loadingSaveData: false,
      form: {
        name: this.barrier ? this.barrier.name : "",
        article: this.barrier ? this.barrier.article : null,
        status: this.barrier ? parseInt(this.barrier.status) : 1,
        length_to_repeat: this.barrier ? this.barrier.length_to_repeat : null,
        length_door: this.barrier ? this.barrier.length_door : null,
        height_on_earth: this.barrier ? this.barrier.height_on_earth : null,
        price_pog_metr: this.barrier ? this.barrier.price_pog_metr : null,
        price_installation: this.barrier
          ? this.barrier.price_installation
          : null,
        price_add_stolbik: this.barrier ? this.barrier.price_add_stolbik : null,
        price_installation_in_base: this.barrier
          ? this.barrier.price_installation_in_base
          : null,

        cost_pog_metr: this.barrier ? this.barrier.cost_pog_metr : null,
        cost_installation: this.barrier ? this.barrier.cost_installation : null,
        cost_add_stolbik: this.barrier ? this.barrier.cost_add_stolbik : null,
        cost_installation_in_base: this.barrier
          ? this.barrier.cost_installation_in_base
          : null,

        bez_kalitki: this.barrier
          ? this.barrier.bez_kalitki == true
            ? 1
            : 0
          : 0,
        bez_prohoda: this.barrier
          ? this.barrier.bez_prohoda == true
            ? 1
            : 0
          : 0,
        type_id: this.barrier ? this.barrier.type_id : null,
        selectedModel3dCanvas: null,
        selectedModel3dColumn: null,
        selectedModel3dGate: null,
        selectedImage: null,
        removeModel3dCanvas: null,
        removeModel3dColumn: null,
        removeModel3dGate: null,
        removeImage: null,
      },
    };
  },
  mounted() {
    if (!this.licensed) this.$router.push({ name: "no_license" });
  },
  computed: {
    types() {
      return this.$store.state.barriers.types;
    },
    licensed() {
      return this.$store.getters["licensed"];
    },
  },
  methods: {
    selectFile(file, dataProps) {
      this.form[`selected${dataProps}`] = file;
      this.form[`remove${dataProps}`] = false;
    },
    removeFile(dataProps) {
      this.form[`selected${dataProps}`] = null;
      this.form[`remove${dataProps}`] = true;
    },

    async saveClose() {
      const element = await this.saveData();
      if (element) {
        this.$router.replace({
          name: "barriers",
          query: { ...this.$route.query },
        });
      }
    },
    async save() {
      const element = await this.saveData();
      if (element) {
        this.$router
          .push({
            name: "edit_barrier",
            params: {
              barrier_id: element.barrier.barrier_id,
            },
            query: { ...this.$route.query },
          })
          .catch((error) => {});
      }
    },

    async saveCreate() {
      const newElement = await this.saveData();
      if (newElement) {
        if (this.$route.name == "add_barrier") {
          window.location.reload();
        } else {
          await this.$router
            .replace({
              name: "add_barrier",
              query: { ...this.$route.query },
            })
            .catch((error) => {});
        }
      }
    },

    async saveCopy() {
      const element = await this.saveData();
      if (element) {
        const clone = await this.$store.dispatch(
          "barriers/copySingle",
          element.barrier.barrier_id
        );
        await this.$router.push(
          {
            name: "edit_barrier",
            params: {
              barrier_id: clone.barrier.barrier_id,
            },
            query: { ...this.$route.query },
          },
          () => {
            location.reload();
          }
        );
      }
    },

    async saveData() {
      this.errors = null;
      this.loadingSaveData = true;
      try {
        let formDataPost = new FormData();

        if (this.barrier) formDataPost.append("_method", "PATCH");

        formDataPost.append("name", this.form.name);
        formDataPost.append("article", this.form.article);
        formDataPost.append("type_id", this.form.type_id);
        formDataPost.append("status", parseInt(this.form.status));
        formDataPost.append("length_to_repeat", this.form.length_to_repeat);
        formDataPost.append("length_door", this.form.length_door);
        formDataPost.append("height_on_earth", this.form.height_on_earth);
        formDataPost.append("bez_kalitki", this.form.bez_kalitki);
        formDataPost.append("price_pog_metr", this.form.price_pog_metr);
        formDataPost.append("price_installation", this.form.price_installation);
        formDataPost.append("price_add_stolbik", this.form.price_add_stolbik);
        formDataPost.append(
          "price_installation_in_base",
          this.form.price_installation_in_base
        );
        formDataPost.append("cost_pog_metr", this.form.cost_pog_metr);
        formDataPost.append("cost_installation", this.form.cost_installation);
        formDataPost.append("cost_add_stolbik", this.form.cost_add_stolbik);
        formDataPost.append(
          "cost_installation_in_base",
          this.form.cost_installation_in_base
        );
        formDataPost.append("bez_prohoda", this.form.bez_prohoda);

        if (this.form.selectedImage !== null) {
          formDataPost.append("image", this.form.selectedImage);
        }

        if (this.form.selectedModel3dCanvas !== null) {
          formDataPost.append("model3dcanvas", this.form.selectedModel3dCanvas);
        }
        if (this.form.selectedModel3dColumn !== null) {
          formDataPost.append("model3dcolumn", this.form.selectedModel3dColumn);
        }
        if (this.form.selectedModel3dGate !== null) {
          formDataPost.append("model3dgate", this.form.selectedModel3dGate);
        }

        if (this.form.removeImage) {
          formDataPost.append("remove_image", this.form.removeImage);
        }

        if (this.form.removeModel3dCanvas) {
          formDataPost.append(
            "remove_model3d_canvas",
            this.form.removeModel3dCanvas
          );
        }

        if (this.form.removeModel3dColumn) {
          formDataPost.append(
            "remove_model3d_column",
            this.form.removeModel3dColumn
          );
        }
        if (this.form.removeModel3dGate) {
          formDataPost.append(
            "remove_model3d_gate",
            this.form.removeModel3dGate
          );
        }

        let url = `/api/admin/barriers`;
        if (this.barrier)
          url = `/api/admin/barriers/${this.barrier.barrier_id}`;

        const res = (
          await axios.post(url, formDataPost, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
        ).data;
        return res.data;
      } catch (error) {
        this.errors = error.response && error.response.data.errors;
        this.status = error.response && error.response.status;
        if (error.response) {
          const notification = {
            type: "error",
            message:
              error.response &&
              error.response.data &&
              error.response.data.message,
          };
          this.$store.dispatch("notification/add", notification, {
            root: true,
          });
        }
      } finally {
        this.loadingSaveData = false;
      }
    },
  },
};
</script>
